import LocalStoragePersistence from "./LocalStoragePersistence";
import EntityLocalStorageKey from "./EntityLocalStorageKey";
import { DtoId } from "../../dto/DtoId";
import { EntityDTO } from "../../dto/v4/EntityDTO";
import { ParseError } from "../../dto/parsing/JsonParsing";
import { err, ok, Result } from "neverthrow";

export abstract class DtoLocalStoragePersistence<DTO extends EntityDTO> {
  abstract persist(dto: DTO): void;

  public doesDtoExist(identifier: DtoId): boolean {
    return LocalStoragePersistence.doesKeyExist(
      this.localStorageKey(identifier),
    );
  }

  protected abstract schemaVersion(): number;

  protected abstract localStorageKey(identifier: DtoId): EntityLocalStorageKey;

  public load(identifier: DtoId): Result<DTO | undefined, ParseError> {
    return LocalStoragePersistence.read<DTO | undefined>(
      this.localStorageKey(identifier),
    )
      .andThen((parsedJson) =>
        this.validateSchemaVersion(
          identifier,
          parsedJson,
          this.schemaVersion(),
        ),
      )
      .andThen((parsedJson) =>
        parsedJson !== undefined
          ? ok(this.buildFromParsedJson(parsedJson))
          : ok(undefined),
      );
  }

  protected abstract buildFromParsedJson(parsedJson: DTO): DTO;

  private validateSchemaVersion(
    identifier: DtoId,
    successfulResult: DTO | undefined,
    schemaVersionToAssert: number,
  ): Result<DTO | undefined, ParseError> {
    if (successfulResult === undefined) {
      return ok(undefined);
    } else if (schemaVersionToAssert == successfulResult.schemaVersion) {
      return ok(successfulResult);
    } else {
      return err({
        message: `DTO with identifier=${identifier} failed schema assertion. expected=${schemaVersionToAssert} actual=${successfulResult.schemaVersion}`,
        content: JSON.stringify(successfulResult),
        error: undefined,
      });
    }
  }
}
